import { render } from "./PageViewer.vue?vue&type=template&id=1b472656&scoped=true"
import script from "./PageViewer.vue?vue&type=script&lang=js"
export * from "./PageViewer.vue?vue&type=script&lang=js"

import "./PageViewer.vue?vue&type=style&index=0&id=1b472656&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b472656"]])

export default __exports__